import { render } from "./MaxValue.vue?vue&type=template&id=51db2a11"
import script from "./MaxValue.vue?vue&type=script&lang=js"
export * from "./MaxValue.vue?vue&type=script&lang=js"

import "./MaxValue.vue?vue&type=style&index=0&id=51db2a11&lang=css"
script.render = render

export default script